import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initSimulateChannelsFromUrl } from '@/lib/dev/simulateAllChannelsConnected.js';

// Navigation tracker — logs page views to console only (Base44 logging removed)
export default function NavigationTracker() {
    const location = useLocation();

    useEffect(() => {
        // TEMPORARY DEV/TEST TOOL — pick up ?simulate=on|off on client-side navigations
        initSimulateChannelsFromUrl(location.search);

        if (import.meta.env?.DEV) {
            console.debug('[nav]', location.pathname);
        }
    }, [location]);

    return null;
}
